// extracted by mini-css-extract-plugin
module.exports = {"container":"AthleteBlock_container__D1PtC","wrapper":"AthleteBlock_wrapper__i27dK"};